import Icon from "./icons/Icon";
import { AUFGABEN } from "../aufgaben";
import "./Auswahl.css";

/**
 * Spielmodus: zwei Karten, eine ist gewaehlt.
 * @category eingaben
 */
export function ModusWahl({ wert, onChange }) {
  const karten = [
    // Buzzer zuerst: so wird inzwischen fast immer gespielt
    // Icons zeigen den Unterschied: mehrere Handys vs. eines fuer alle
    ["BUZZER", "handys", "Buzzer", "Jeder buzzert am eigenen Handy."],
    ["CLASSIC", "handy", "Zuruf", "Ein Handy für alle, ihr ruft laut."],
  ];
  return (
    <div className="modi" role="radiogroup" aria-label="Spielmodus">
      {karten.map(([key, icon, titel, text]) => (
        <button
          key={key}
          type="button"
          role="radio"
          aria-checked={wert === key}
          className={`modus${wert === key ? " an" : ""}`}
          onClick={() => onChange(key)}
        >
          {wert === key && (
            <span className="modus-haken" aria-hidden="true">
              <Icon name="check" size={14} />
            </span>
          )}
          <span className="modus-ikon">
            <Icon name={icon} size={22} />
          </span>
          <b>{titel}</b>
          <span className="modus-text">{text}</span>
        </button>
      ))}
    </div>
  );
}

/**
 * Welche Fragen vorkommen: vier Schalter mit Icon (Titel, Interpret, Jahr, Album).
 * @category eingaben
 */
export function FragenWahl({ activeTasks, setActiveTasks }) {
  return (
    <div className="schalter-gitter">
      {Object.keys(activeTasks).map((typ) => (
        <button
          key={typ}
          type="button"
          className={`schalt${activeTasks[typ] ? " an" : ""}`}
          aria-pressed={!!activeTasks[typ]}
          onClick={() => setActiveTasks({ ...activeTasks, [typ]: !activeTasks[typ] })}
        >
          <Icon name={AUFGABEN[typ]?.icon || "titel"} size={18} />
          {AUFGABEN[typ]?.name || typ}
        </button>
      ))}
    </div>
  );
}

export const ZEITEN = [0, 1, 5, 10, 20, 30];
const zeitText = (s) => (s === 0 ? "Ohne" : `${s} s`);

/**
 * Zeit pro Song. 0 = ohne Limit, 1 s fuer Profis. Ein gespeicherter Wert
 * ausserhalb der Liste (z. B. 2 s aus alten Spielstaenden) bleibt sichtbar.
 * @category eingaben
 */
export function ZeitWahl({ wert, onChange }) {
  const zeiten = ZEITEN.includes(wert) ? ZEITEN : [...ZEITEN, wert].sort((a, b) => a - b);
  return (
    <div className="zeit-reihe" role="radiogroup" aria-label="Zeit pro Song">
      {zeiten.map((s) => (
        <button
          key={s}
          type="button"
          role="radio"
          aria-checked={wert === s}
          className={`schalt${wert === s ? " an" : ""}`}
          onClick={() => onChange(s)}
        >
          {zeitText(s)}
        </button>
      ))}
    </div>
  );
}
